import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Stack,
  useTheme,
} from "@mui/material";

const PostItem = ({ post, onEdit, onDelete }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: "#1d1915",
        borderRadius: 3,
        p: 2,
        boxShadow: "0 0 20px rgba(0,0,0,0.5)",
      }}
    >
      <Paper
        elevation={5}
        sx={{
          height: 560,
          borderRadius: 3,
          p: 2,
          background: "linear-gradient(145deg, #252018, #2e281f)",
          border: "1px solid rgba(255,255,255,0.1)",
          color: "#e0e0e0",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Top Notch */}
        <Box
          sx={{
            width: 80,
            height: 6,
            backgroundColor: "rgba(255,255,255,0.2)",
            borderRadius: 2,
            position: "absolute",
            top: 10,
            left: "50%",
            transform: "translateX(-50%)",
          }}
        />

        {/* Scrollable Content */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            pt: 4,
            pr: 1,
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(255,255,255,0.2)",
              borderRadius: "4px",
            },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              mb: 1,
              color: "#fff",
              fontWeight: "bold",
              textShadow: "0 0 6px rgba(255,255,255,0.2)",
            }}
          >
            Title: {post.title}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#bdbdbd",
              lineHeight: 1.6,
              wordBreak: "break-word",
              mb: 2,
            }}
            component="div"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          <Typography
            variant="body2"
            sx={{
              fontWeight: "bold",
              color: post.isActive ? "#4caf50" : "#f44336",
            }}
          >
            Status: {post.isActive ? "Active" : "Inactive"}
          </Typography>
        </Box>

        {/* Buttons */}
        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={() => onEdit(post)}
            sx={{
              background: "linear-gradient(135deg, #ffb300, #ff9800)",
              color: "#000",
              fontWeight: "bold",
              fontSize: "0.8rem",
              "&:hover": {
                filter: "brightness(1.2)",
                background: "linear-gradient(135deg, #ffc107, #ffa726)",
              },
            }}
          >
            ✏️ Edit
          </Button>

          <Button
            fullWidth
            variant="contained"
            onClick={() => onDelete(post._id)}
            sx={{
              background: "linear-gradient(135deg, #e53935, #b71c1c)",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "0.8rem",
              "&:hover": {
                filter: "brightness(1.2)",
                background: "linear-gradient(135deg, #ef5350, #c62828)",
              },
            }}
          >
            🗑 Delete
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default PostItem;
